import Model, { attr } from '@warp-drive/legacy/model';

import editorPermissons from 'umg-ember-backend/permissions/user-roles/2-editor';
import authorPermissons from 'umg-ember-backend/permissions/user-roles/3-author';
import jobPermissons from 'umg-ember-backend/permissions/user-roles/4-job';
import urlShortnerPermissons from 'umg-ember-backend/permissions/user-roles/5-url-shortner';
import assetPermissons from 'umg-ember-backend/permissions/user-roles/7-asset';
import artistPermissons from 'umg-ember-backend/permissions/user-roles/8-artist';
import liveEventPermissons from 'umg-ember-backend/permissions/user-roles/9-live-event';
import assetMasterPermissons from 'umg-ember-backend/permissions/user-roles/10-asset-master';
import developerPermissons from 'umg-ember-backend/permissions/user-roles/11-developer';
import readOnlyPermissons from 'umg-ember-backend/permissions/user-roles/12-read-only';
import editorAndMlpTesterPermissons from 'umg-ember-backend/permissions/user-roles/13-editor-and-mlp-tester';
import frontendUserPermissons from 'umg-ember-backend/permissions/user-roles/14-frontend-user';
import articleEditorPermissons from 'umg-ember-backend/permissions/user-roles/15-article-editor';
import crmPermissons from 'umg-ember-backend/permissions/user-roles/16-crm';
import productPermissons from 'umg-ember-backend/permissions/user-roles/17-product';
import sftpUserPermissons from 'umg-ember-backend/permissions/user-roles/18-sftp-user';
import managementPermissons from 'umg-ember-backend/permissions/user-roles/20-management';
import labelPermissons from 'umg-ember-backend/permissions/user-roles/24-label';
import umgClassicEventPermissons from 'umg-ember-backend/permissions/user-roles/25-umg-classic-event';
import webSeriesPermissons from 'umg-ember-backend/permissions/user-roles/27-web-series';
import youniverseEditorPermissons from 'umg-ember-backend/permissions/user-roles/28-youniverse-editor';
import a11yScannerAdmin from 'umg-ember-backend/permissions/user-roles/29-a11y-scanner-admin';
import a11yScannerViewer from 'umg-ember-backend/permissions/user-roles/30-a11y-scanner-viewer';
import editorInternationalPermissions from 'umg-ember-backend/permissions/user-roles/31-editor-international';
import customerSupportPermissions from 'umg-ember-backend/permissions/user-roles/32-customer-support';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
});

const permissions = {
  2: editorPermissons,
  3: authorPermissons,
  4: jobPermissons,
  5: urlShortnerPermissons,
  7: assetPermissons,
  8: artistPermissons,
  9: liveEventPermissons,
  10: assetMasterPermissons,
  11: developerPermissons,
  12: readOnlyPermissons,
  13: editorAndMlpTesterPermissons,
  14: frontendUserPermissons,
  15: articleEditorPermissons,
  16: crmPermissons,
  17: productPermissons,
  18: sftpUserPermissons,
  20: managementPermissons,
  24: labelPermissons,
  25: umgClassicEventPermissons,
  27: webSeriesPermissons,
  28: youniverseEditorPermissons,
  29: a11yScannerAdmin,
  30: a11yScannerViewer,
  31: editorInternationalPermissions,
  32: customerSupportPermissions,
};

export default class UserRoleModel extends Model.extend(Validations) {
  // Attributes
  @attr('string') name;
  @attr('boolean') isAdmin;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }

  // Functions
  get permissions() {
    return permissions[this.id];
  }
}
